"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatPhoneNumberUkMobile;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatPhoneNumberUkMobile() {
  var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = phoneNumber;
  if (!(0, _isString["default"])(value)) {
    return '';
  }

  // ensure string can only start with single +
  if (value.substring(1).indexOf('+') !== -1) {
    value = value.substring(0, 1) + value.substring(1).replace(/\+/g, '');
  }

  // replace 00 with +
  if ((0, _startsWith["default"])(value, '00')) {
    value = value.replace(/^00/, '+');
  }

  // replace +00 with +
  if ((0, _startsWith["default"])(value, '+00')) {
    value = value.replace(/^\+00/, '+');
  }
  return value.replace(/[^+0-9]/g, '');
}